// Odświeżanie przeciągnięciem w dół (właściciel 18.10: „takie aplikacyjne”) = pełne przeładowanie APP, także
// z nową wersją. Działa tylko palcem, tylko gdy strona jest przewinięta do góry i ruch jest pionowy; suwaki i okna
// nie startują gestu. Powłoka przewija cały dokument (pakiet wyglądu). Ruch wskaźnika poza Reactem (zmienna CSS na
// elemencie) - przeciąganie nie przerysowuje ekranu.
import { useEffect, useRef } from "react";
import { t } from "../i18n/t";
import { IkonaOdswiez } from "./ikony";

const PROG_PX = 70; // tyle (po oporze) trzeba przeciągnąć, żeby puszczenie odświeżyło
const MAX_PX = 110;
const OPOR = 0.5;

export function Odswiezanie() {
  const wskaznik = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const w = wskaznik.current;
    if (!w) return;
    let start: { x: number; y: number } | null = null;
    let droga = 0;
    let pionowo = false;
    const pokaz = (px: number) => {
      droga = px;
      w.style.setProperty("--iot-ciag", px + "px"); // droga palca - w pikselach ekranu, niezależnie od rozmiaru czcionki
      w.style.setProperty("--iot-obrot", px * 3 + "deg");
      w.classList.toggle("is-gotowe", px >= PROG_PX);
      w.classList.toggle("is-widoczne", px > 0);
    };
    const poczatek = (e: TouchEvent) => {
      const cel = e.target as HTMLElement;
      if (window.scrollY > 0 || e.touches.length !== 1 || cel.closest("input, textarea, select, [role=dialog]")) return;
      const p = e.touches[0];
      if (p) start = { x: p.clientX, y: p.clientY };
      pionowo = false;
    };
    const ruch = (e: TouchEvent) => {
      const p = e.touches[0];
      if (!start || !p) return;
      const dy = p.clientY - start.y, dx = p.clientX - start.x;
      if (!pionowo) {
        if (Math.abs(dx) > Math.abs(dy) || dy <= 0) { start = null; return; }
        if (dy > 8) pionowo = true; else return;
      }
      if (window.scrollY > 0) { start = null; pokaz(0); return; }
      e.preventDefault(); // w trakcie gestu strona się nie przewija
      pokaz(Math.min(MAX_PX, dy * OPOR));
    };
    const koniec = () => {
      if (!start) return;
      start = null;
      if (droga >= PROG_PX) {
        w.classList.add("is-laduje");
        window.location.reload();
        return;
      }
      pokaz(0);
    };
    document.addEventListener("touchstart", poczatek, { passive: true });
    document.addEventListener("touchmove", ruch, { passive: false });
    document.addEventListener("touchend", koniec);
    document.addEventListener("touchcancel", koniec);
    return () => {
      document.removeEventListener("touchstart", poczatek);
      document.removeEventListener("touchmove", ruch);
      document.removeEventListener("touchend", koniec);
      document.removeEventListener("touchcancel", koniec);
    };
  }, []);
  return (
    <div ref={wskaznik} className="iot-odswiez" aria-hidden="true" data-test="odswiez">
      <span className="iot-odswiez__kolo"><IkonaOdswiez /></span>
      <span className="iot-odswiez__tekst">{t("Puść, aby odświeżyć")}</span>
    </div>
  );
}
